import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { AppProviders } from './providers/AppProviders';
import { router } from './router';
import { initOutbox } from '@/services/outbox-senders';

export function App() {
  // A fila de escrita arranca com a app: taps que ficaram por enviar numa sessão
  // anterior (rede em baixo, app fechada a meio) drenam agora.
  useEffect(() => { initOutbox(); }, []);

  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
